// extracted by mini-css-extract-plugin
export default {"banner":"GovernmentSupportBanner_banner__GzmN+","banner_tablet":"GovernmentSupportBanner_banner_tablet__1C0H2"};